export const Archive = () => (
  <path d='M20.2,21.2H3.8c-0.5,0-0.9-0.4-0.9-0.9v-11H1.9C1.4,9.2,1,8.8,1,8.3V3.8c0-0.5,0.4-0.9,0.9-0.9h20.2c0.5,0,0.9,0.4,0.9,0.9v4.6c0,0.5-0.4,0.9-0.9,0.9h-0.9v11C21.2,20.8,20.8,21.2,20.2,21.2z M4.7,19.3h14.7V9.2H4.7V19.3z M2.8,7.4h18.3V4.7H2.8V7.4z M13.8,12.9h-3.7c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h3.7c0.5,0,0.9,0.4,0.9,0.9S14.3,12.9,13.8,12.9z' />
)
